"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SettingsModule = /** @class */ (function () {
    function SettingsModule() {
    }
    return SettingsModule;
}());
exports.SettingsModule = SettingsModule;
